import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";

/**
 * @class CustomField
 * @property {number} id
 * @property {Property} property
 * @property {string} name
 * @property {string} type
 */
export class CustomField extends TranslatableModel {

    static get APPLY_TO_RESERVATION() {
        return {
            key: 1,
            value: 'APPLY_TO_RESERVATION',
        };
    }
    static get APPLY_TO_INDIVIDUAL_CUSTOMER() {
        return {
            key: 2,
            value: 'APPLY_TO_INDIVIDUAL_CUSTOMER',
        };
    }
    static get APPLY_TO_CORPORATE_CUSTOMER() {
        return {
            key: 3,
            value: 'APPLY_TO_CORPORATE_CUSTOMER',
        };
    }

    static get TYPE_INPUT() {

        return 1;
    }
    static get TYPE_AREA() {

        return 2;
    }
    static get TYPE_CHECKLIST() {

        return 3;
    }
    static get TYPE_RADIO() {

        return 4;
    }

    static get TYPES() {

        return [
            this.constructor.TYPE_INPUT,
            this.constructor.TYPE_AREA,
            this.constructor.TYPE_CHECKLIST,
            this.constructor.TYPE_RADIO,
        ];
    }

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'name' ];
    }
    
    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }

    static defaultFieldsParams(applies = []) {

        const appliedParams = applies.reduce((all, applied, index) => {

            all[`applies[${index}]`] = applied;

            return all;
        }, {});

        return Object.assign(appliedParams,{
            'display_card': 1,
            'types[0]': CustomField.TYPE_RADIO,
        });
    };
    
    static get validationModel() {
        
        return {
            name: {
                label: 'CUSTOM_FIELD_NAME_IN_ENGLISH',
                commonLabel: 'Custom Field name'
            },
            name_ar: {
                label: 'CUSTOM_FIELD_NAME_IN_ARABIC',
                commonLabel: 'Custom Field name'
            },
            type: {
                label: 'FIELD_TYPE',
            }
        };
    }
}

AccessorsMutatorsDecorator(
    'id', ...CustomField.translatableAttributesWithLanguageAliases, 'property', 'short_code', 'apply_to', 'required',
    'display_direct_reservations', 'display_internet_booking_engine', 'display_registration_card', 'type', 'max_characters',
    'checklist_options', 'radio_options', 'selected_radio_option', 'order', 'allow_multiselect', 'editable')(CustomField);



// WEBPACK FOOTER //
// ./src/pms-api/models/custom-field.model.js